<template>
  <div class="notifications">
    <div
      v-for="offer in offers"
      :key="offer.key"
      class="notification"
    >
      <div class="info block">
        <a
          class="title"
          :href="offer.href"
          :target="offer.linkTarget"
          @click="updateCookieClick(offer)"
          @auxclick="updateCookieClick(offer)"
        >
          <div :class="{ visited: isChecked(offer.key) }">
            {{ offer.label }}
          </div>
          <div class="read-more-link">
            {{ $t('link.readMore') }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import CookieUtils from 'utils/CookieUtils'
  import gtmOffers from 'services/AirBaltic/GTM/Offers'

  export default {
    props: {
      offers: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      offerList() {
        const cookie = CookieUtils.getCookie('notificationsAlerts').split(',')

        return new Map(cookie.map((key) => [key, true]))
      }
    },
    methods: {
      isChecked(key) {
        return this.offerList.has(key)
      },
      updateCookie(offerKey) {
        if (!this.offerList.has(offerKey)) {
          this.offerList.set(offerKey, true)
        }

        const readOffersArray = Array.from(this.offerList.keys())
        CookieUtils.setCookie('notificationsAlerts', readOffersArray.join(','), 0)
      },
      updateCookieClick(offer) {
        this.updateCookie(offer.key)
        gtmOffers.offersOpen(offer.label, offer.key)
        this.$emit('updateCount')
      },
      showTooltipEmail() {
        this.showTooltip.email = true
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .notifications {
    display: flex;
    flex-direction: column;

    .notification {
      border-bottom: 1px solid $grey-border;
      display: flex;
      flex-direction: row;

      .block {
        width: 10%;
      }

      .info {
        padding-right: 10px;
        padding-bottom: 20px;
        flex-grow: 1;
      }

      &:first-child {
        .title {
          &:first-child {
            margin-top: 0;
          }
        }
      }

      &:last-child {
        border-bottom: none;

        .read-more-link {
          margin-bottom: 0;
        }
      }
    }
  }

  .title {
    display: block;
    margin-top: 14px;
    font-size: rem(16, 16);
    line-height: rem(18, 16);
    font-weight: 500;
    color: black;

    .visited {
      color: $gray-text-muted;
      font-weight: 400;
    }
  }

  .read-more-link {
    display: block;
    margin-top: 8px;
    font-size: rem(12, 16);
    line-height: rem(16, 16);
    font-weight: 400;
    color: $blue-medium;
  }

  a {
    text-decoration: none;
  }
</style>
